import { render } from "./ObjectNeedsReviewIcon.vue?vue&type=template&id=1f86f09c&scoped=true"
import script from "./ObjectNeedsReviewIcon.vue?vue&type=script&lang=js"
export * from "./ObjectNeedsReviewIcon.vue?vue&type=script&lang=js"

import "./ObjectNeedsReviewIcon.vue?vue&type=style&index=0&id=1f86f09c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f86f09c"]])

export default __exports__